import React from "react";
import './home.css'
import MainMessage from '../mainmessage/mainmessage'
// import Booking from '../booking/booking'
import Emirates from '../emirates/emirates'
import SecondaryMessage from '../secondarymessage/secondarymessage';
import CountUpper from '../count-up/count-up';
// import TwoOptions from './two-options/two-options';
import GetPosition from '../get-position/get-position'

export default function Home() {
    return (
        <div>
            <MainMessage/>
            <GetPosition/>
            <Emirates/>
            <CountUpper/>
            <SecondaryMessage/>
        </div>
    )
}